import { compose, withProps, withHandlers, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { CUSTOM_PRICE_RANGE_FORM } from '../../constants'
import { MAX_PRICE_INPUT_NAME, MIN_PRICE_INPUT_NAME } from './constants'
import CustomPriceRangeForm from './CustomPriceRangeForm'
import { applyPriceRangeFilter } from '../../actions'
import viewModel from './viewModel'
import validate from './validate'
import { getCustomPriceFilter } from 'helpers/custom-price-filter'

const withSubmitHandlers = withHandlers({
  onSubmit: ({ applyPriceRangeFilter, navigationState, count }) =>
    ({ [MIN_PRICE_INPUT_NAME]: min, [MAX_PRICE_INPUT_NAME]: max }) =>
      applyPriceRangeFilter({ min, max, navigationState, count })
})

const withNavigationStateAndViewModel = withProps(({ refinements }) => {
  const [{ navigationState } = {}] = (getCustomPriceFilter(refinements) || [])
  return {
    vm: viewModel,
    navigationState
  }
})

const withHideIfNoRecord = branch(({ navigationState }) => !navigationState,
  renderNothing
)

export default compose(
  connect(null, { applyPriceRangeFilter }),
  withNavigationStateAndViewModel,
  withSubmitHandlers,
  withHideIfNoRecord,
  reduxForm({ form: CUSTOM_PRICE_RANGE_FORM, validate })
)(CustomPriceRangeForm)
